import React from 'react';
import { useSnackbar } from 'notistack';
const useSnackMessage = () => {
    const { enqueueSnackbar } = useSnackbar();
    const showSnackBar = React.useCallback((msg, options) => enqueueSnackbar(msg, options), [enqueueSnackbar]);
    return {
        showSnackBar,
        showDefault: React.useCallback((msg, options) => showSnackBar(msg, { ...options, variant: 'default' }), [showSnackBar]),
        showError: React.useCallback((msg, options) => showSnackBar(msg, { ...options, variant: 'error' }), [showSnackBar]),
        showInfo: React.useCallback((msg, options) => showSnackBar(msg, { ...options, variant: 'info' }), [showSnackBar]),
        showSuccess: React.useCallback((msg, options) => showSnackBar(msg, { ...options, variant: 'success' }), [showSnackBar]),
        showWarning: React.useCallback((msg, options) => showSnackBar(msg, { ...options, variant: 'warning' }), [showSnackBar]),
    };
};
export default useSnackMessage;
